module.exports = __webpack_public_path__ + "static/media/dawulunshan_plant.818cbfa4.png";